<template>
  <div>
    <div v-if="loading" class="md-layout preloader">
      <div class="md-layout-item md-size-100">
        <md-progress-bar md-mode="indeterminate"></md-progress-bar>
       </div>
      <div class="md-layout-item md-size-100 label">
        <span class="md-subheading">Загрузка...</span>
      </div>
    </div>
  <div v-if="!loading"  :md-fullscreen="true" class="inventory-view">
      <div class="md-layout">
          <div class="md-layout-item md-size-100 control">
            <div class="md-layout md-alignment-center-center">
              <div class="md-layout-item md-size-50">
                <md-field>
                  <label>Введите код</label>
                  <md-input v-model.lazy="code" type="number" @change="searchCode"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50 save-block">
                <md-button type="button" class="md-raised md-primary" @click="sendUpdate">Сохранить</md-button>
                <span class="md-subheading">Добавлено {{ this.countAddItem }} из {{ this.needAddItem }}</span>
              </div>
            </div>
            </div>

          <div class="md-layout">
              <div class="md-layout-item md-size-75 md-xsmall-size-100">
                <md-table
                    md-card
                    class="md-scrollbar"
                    :style="{
                overflow: 'auto',
                marginRight: 0,
                marginLeft: 0,
              }"
                >
                  <md-table-row>
                    <md-table-head>Продукт</md-table-head>
                    <md-table-head>Запр./Факт</md-table-head>
                    <md-table-head>Поставщик</md-table-head>
                  </md-table-row>
                  <md-table-row
                      v-for="(item, index) in this.list.array_produkt"
                      :key="item.produkt_ID + item.size"
                      class="tr-body"
                      v-bind:class="{'row-active': item.active, 'row-error': (item.estimated_quantity != item.actual_quantity)}"
                      slot="md-table-row"
                      @click="showImage(item)"
                      @mouseenter="showImage(item)"
                      :ref="item.produkt_ID + item.size"
                  >
                    <md-table-cell>{{ item.name }} ({{ item.size_label.toUpperCase() }})</md-table-cell>
                    <md-table-cell>
                      {{ item.estimated_quantity }}/
                      <input type="number" v-model:value="item.actual_quantity"
                                          min="0"
                                          @change="setChanged(item)"
                                          style="width: 40px"
                    /></md-table-cell>
                    <md-table-cell>{{ item.stock_supplier }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
              <div class="md-layout-item md-size-25 md-xsmall-size-100 product-wrap">
                <SimplePhotoProduct v-bind:src="activeItem.link" />
                <!-- Need this empty div to get position sticky work properly -->
                <!-- https://medium.com/web-standards/sticky-bc7ff7088693 -->
                <div />
              </div>
            </div>
      </div>
  </div>
  </div>
</template>

<script>
import SimplePhotoProduct from "../components/SimplePhotoProduct";
// import {StreamBarcodeReader} from "vue-barcode-reader";

const CLEAR_TIMEOUT = 0;

export default {
  name: "InventoryView",
  components: {
    SimplePhotoProduct,
    // StreamBarcodeReader,
  },
  data: () => ({
    id: null,
    getProductByBarcodeId: null,
    loading: true,
    isShowBarcodeReader: false,
    list: [],
    uniqueCodesAlreadyUsed: [],
    activeItem: {
      link: '/icons/android-chrome-512x512.png',
      name: ''
    },
    code: '',
    countAddItem: 0,
    needAddItem: 0,
    foundInTable: false,
    refId: ''
  }),
  // watch: {
  //   code: function (newValue, oldValue) {
  //     if (this.getProductByBarcodeId) {
  //       clearTimeout(this.getProductByBarcodeId);
  //     }
  //     this.getProductByBarcodeId = setTimeout(() => {
  //       this.getProductByBarcode();
  //     }, 500);
  //
  //   }
  // },
  methods: {
    processScroll(refId) {
      this.$refs[refId][0].$el.scrollIntoView({ behavior: "smooth" });
    },
    searchCode() {
      if (this.getProductByBarcodeId) {
        clearTimeout(this.getProductByBarcodeId);
      }
      this.getProductByBarcodeId = setTimeout(() => {
        this.getProductByBarcode();
      }, 500);
    },
    showToastMessage(type, message) {
      this.$store.commit("messages/setMessage", {
        type,
        code : type === 'error' ? 'Ошибка' : 'Успех',
        message,
      });
    },
    scanShow() {
      this.isShowBarcodeReader = !this.isShowBarcodeReader;
      if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
        navigator.mediaDevices.getUserMedia({video: true}).catch(() => {
          this.showToastMessage("error", "Нет доступа к камере");
        });
      }
    },
    // onDecode(a, b, c) {
    //   this.code = a;
    //   if (this.id) {
    //     clearTimeout(this.id);
    //   }
    //   this.id = setTimeout(() => {
    //     if (this.code === a) {
    //       this.code = "";
    //     }
    //   }, 5000);
    // },
    showImage: function (object) {
      this.activeItem.link = object.image;

      this.list.array_produkt.forEach(item => {
        item.active = item.produkt_ID === object.produkt_ID;
      });
    },
    sendUpdate: function () {
      if (this.list) {
        this.$axios
            .post("/inventory", {
              data: this.list,
              code: this.$route.params.docId
            })
            .then(() => {
              this.showToastMessage("success", "Данные успешно обновлены");
            }).catch(() => {
              this.showToastMessage("error", "Ошибка сервера");
            })
            .finally(() => {
              this.loading = false;
              this.$router.push('/inventory');
            });
      }
    },
    setChanged: function (object) {
      this.countAddItem = 0
      this.list.array_produkt.forEach(item => {
        this.countAddItem += parseInt(item.actual_quantity);
      });
    },
    getDoc: function () {
      if (typeof this.$route.params.docId === 'string') {
        this.loading = true;
        this.$axios
            .get("/inventory/get-doc/" + this.$route.params.docId)
            .then((response) => {
              if (typeof response.data === "object") {
                this.list = response.data;
                this.list.array_produkt.forEach((item, index) => {
                  if (index === 0) {
                    this.activeItem.link = item.image;
                  }
                  item.active = false;
                  this.countAddItem += parseInt(item.actual_quantity);
                  this.needAddItem += parseInt(item.estimated_quantity);
                })
              }
            })
            .catch(() => {
              this.showToastMessage("error", "Ошибка сервера");
            })
            .finally(() => {
              this.loading = false;
              this.code = '';
            });
      }
    },
    getProductByBarcode: function () {
      if (this.uniqueCodesAlreadyUsed.includes(this.code)) {
        this.showToastMessage('error', 'Этот товар уже в списке!');

        setTimeout(() => {
          this.code = '';
        }, CLEAR_TIMEOUT);

        return false;
      }

      if (this.code.length > 5)  {
        this.foundInTable = false;
        this.refId = '';

        this.$axios
            .get("/barcode/" + this.code)
            .then((response) => {
              if (response.data.produkt_ID !== undefined && response.data.size !== undefined) {
                this.countAddItem = 0;
                this.addProductToListSuccess(response);
                if (this.foundInTable) {
                  this.showToastMessage('success', `Товар ${this.activeItem.name} найден`);
                  this.activeItem.name = '';
                } else {
                  if (confirm('Товара нет в списке. Хоти добавить товар в список?')) {
                      this.$axios
                        .get("/inventory/get-product/" + response.data.produkt_ID + '/' + response.data.size)
                        .then((response) => {
                          if (response.data.produkt_ID !== undefined && response.data.size !== undefined) {
                            this.list.array_produkt.push(response.data);
                            this.addProductToListSuccess(response);
                          } else {
                            this.showToastMessage("error", "Некорректный ответ с сервера");
                          }
                        })
                        .catch(() => {
                          this.showToastMessage("error", "Ошибка сервера");
                        })
                        .finally(() => {
                          this.loading = false;
                          this.code = '';
                        });
                  }
                }
              }
            })
            .catch((error) => {
              this.showToastMessage('error', 'Ошибка запроса');
            })
            .finally(() => {
              this.loading = false;
              if (this.foundInTable) {
                if (this.refId) {
                  this.processScroll(this.refId);
                }
              }
              setTimeout(() => {
                this.code = '';
              }, CLEAR_TIMEOUT);
            });
        return false;
      }
    },
    addProductToListSuccess: function (response) {
      this.list.array_produkt.forEach(item => {
        if (item.produkt_ID === response.data.produkt_ID && response.data.size === item.size) {
          if (response.data.type !== 'product') {
            this.uniqueCodesAlreadyUsed.push(this.code);
          }
          item.active = true;
          item.actual_quantity++;
          this.activeItem.link = item.image;
          this.activeItem.name = item.name;
          this.foundInTable = true;
          this.refId = item.produkt_ID + item.size;
        } else {
          item.active = false;
        }
        this.countAddItem += parseInt(item.actual_quantity);
      })
    }
  },
  mounted() {
    this.getDoc();
  },
};
</script>

<style lang="scss" scoped>
.preloader .label {
  text-align: center;
}

 .product-wrap /deep/ .product {
  position: sticky;
  top: 0;
}

.inventory-view {
  padding: 8px;
}

.save-block {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.md-content.md-table-content table {
  min-width: 100%;
  max-width: 100%;
  flex: 0 1 100%;
}

.md-content.md-table-content table tr.tr-body:active,
.md-content.md-table-content table tr.tr-body.row-active,
.md-content.md-table-content table tr.tr-body:hover {
  background-color: #448aff !important;
}

.md-content.md-table-content table tr.tr-body.row-error {
  background-color: #ff5252;
}
</style>
